const text = value => String(value ?? '').trim();

export const getProductTeluguName = item =>
  text(item?.product_name_tel || item?.tel_name || item?.teluguname || item?.telugu_name);

export const getBrandedTeluguName = item => {
  const product = getProductTeluguName(item);
  const teluguBrand = text(item?.brand_name_telugu || item?.brand_name_tel);
  const englishBrand = text(item?.brand_name_english || item?.brand_name || item?.brand);
  const brand = teluguBrand || englishBrand;
  if (!product || !brand) return product;
  let remainder = product;
  const aliases = [...new Set([teluguBrand, englishBrand].filter(Boolean))]
    .sort((a, b) => b.length - a.length);
  // Replace existing brand prefixes in either language, including repeated prefixes.
  while (remainder) {
    const candidate = remainder;
    const alias = aliases.find(value => {
      const start = candidate.slice(0, value.length);
      const next = candidate.slice(value.length, value.length + 1);
      return start.toLocaleLowerCase() === value.toLocaleLowerCase() &&
        (!next || /[\s:–—-]/.test(next));
    });
    if (!alias) break;
    remainder = remainder.slice(alias.length).replace(/^[\s:–—-]+/, '');
  }
  return remainder ? `${brand} ${remainder}` : brand;
};

// Use catalog identities, never a fuzzy English-name match.
export const createCatalogTeluguResolver = (catalogBarcodes = []) => {
  const ids = new Map();
  const barcodes = new Map();
  const codes = new Map();
  const add = (map, key, name) => {
    key = text(key);
    if (!key || !name) return;
    map.set(key, map.has(key) && map.get(key) !== name ? null : name);
  };
  catalogBarcodes.forEach(row => {
    const name = getBrandedTeluguName(row);
    add(ids, row.id, name);
    add(barcodes, row.mk_barcode, name);
    add(barcodes, row.barcode, name);
    add(codes, row.product_code, name);
  });
  return item => {
    const sku = text(item?.sku_id || item?.SKU);
    const skuPackId = sku.match(/-PB(\d+)(?:-|$)/)?.[1];
    const code = text(item?.product_code) || sku.split(/-PB\d+(?:-|$)/)[0];
    return ids.get(text(item?.product_barcode_id || item?.barcode_id || skuPackId)) ||
      barcodes.get(text(item?.bar_code || item?.mk_barcode || item?.Barcode)) ||
      codes.get(code) || getBrandedTeluguName(item);
  };
};
